// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__Eb8K1","fill":"ProgressBar_fill__CenZ+"};